var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIosIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.84,20.89A17.86,17.86,0,0,1,24.2,24c-1.06,1.62-2.56,3.64-4.42,3.66-1.66,0-2.08-1.08-4.32-1.06s-2.71,1.08-4.36,1.06c-1.86,0-3.28-1.84-4.35-3.46-3-4.53-3.29-9.84-1.45-12.67a6.6,6.6,0,0,1,5.3-3.19c2,0,3.21,1.08,4.84,1.08S18,8.29,20.26,8.29a6.43,6.43,0,0,1,4.84,2.56A5.54,5.54,0,0,0,25.84,20.89Z",
    style: {
      fill: "#5f6b78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.53,6.48a5.54,5.54,0,0,0,1.23-4.09A6,6,0,0,0,15.9,4.46a5.13,5.13,0,0,0-1.26,4A5.06,5.06,0,0,0,18.53,6.48Z",
    style: {
      fill: "#5f6b78"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosIcon);
export default __webpack_public_path__ + "static/media/ios_icon.f00af32c410d0d4d7ea62356de6e2ee5.svg";
export { ForwardRef as ReactComponent };